import { render } from "./DianChi.vue?vue&type=template&id=51f1554c&scoped=true"
import script from "./DianChi.vue?vue&type=script&lang=js"
export * from "./DianChi.vue?vue&type=script&lang=js"

import "./DianChi.vue?vue&type=style&index=0&id=51f1554c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f1554c"]])

export default __exports__